// extracted by mini-css-extract-plugin
export default {"header-btn":"TenderInfoBtn_header-btn__MWBkm"};